module.exports = __webpack_public_path__ + "static/media/filmm2022.ddf7159b.png";